<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="denomination.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Shop"
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  readonly
                  :rules="rules.shopRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="denomination.type"
                  :items="typeList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Type"
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.typeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="denomination.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Currency"
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  @change="changeCurrency(denomination.currencyId)"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="description"
                  label="Description"
                  v-model="denomination.description"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.descriptionRuless"
                ></v-textarea>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="kPayAmount"
                  label="K Pay Amount"
                  min="0"
                  v-model="denomination.kpayAmount"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.kPayAmountRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="bankTransferAmount"
                  label="Bank Transfer Amount"
                  min="0"
                  v-model="denomination.bankTransferAmount"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.bankTransferRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="denomination.id">
                <v-autocomplete
                  v-model="denomination.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="denomination.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="denomination.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="denomination.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="denomination.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="denomination.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="denomination.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <div>
                    <span
                      style="
                        padding-right: 15px;
                        padding-left: 20px;
                        font-size: 17px;
                      "
                      >RECEIVE CASH AMOUNT</span
                    >
                    <v-chip>
                      <span>{{ denomination.cashAmount | decFormat }}</span>
                    </v-chip>
                  </div>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-card color="grey lighten-4">
                  <v-card-text>
                    <v-layout row wrap class="light--text">
                      <v-flex xs2>CASH NOTES</v-flex>
                      <v-flex xs1>QTY</v-flex>
                      <v-flex xs2 style="text-align: center"
                        >CASH AMOUNT</v-flex
                      >
                    </v-layout>
                    <v-layout
                      row
                      wrap
                      v-for="(
                        denominationDetail, index
                      ) in denomination.denominationDetailList"
                      :key="index"
                    >
                      <v-flex xs2 style="padding-right: 50px">
                        <v-text-field
                          v-model="denominationDetail.cashNoteValue"
                          :readonly="true"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                        <v-text-field
                          v-model="denominationDetail.qty"
                          background-color="white"
                          type="number"
                          min="0"
                          oninput="this.value = Math.abs(this.value)"
                          v-on:change="calculateReceiveCashAmount()"
                          :rules="rules.qtyRules"
                          :readonly="status != 'DRAFT'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm2 pt-4 style="text-align: center">
                        {{
                          (denominationDetail.cashNoteValue *
                            denominationDetail.qty)
                            | decFormat
                        }}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-flex sm12>
                    <div class="text-xs-center">
                      <v-btn
                        color="error"
                        @click="clear"
                        :disabled="status != 'DRAFT'"
                      >
                        Reset
                        <v-icon right>clear</v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        :loading="saveLoading"
                        :readonly="!valid"
                        @click="onSave"
                        :disabled="status != 'DRAFT' || saveLoading"
                      >
                        Save
                        <v-icon right>save</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { currencyService } from "../../services/currency-service";
import { Denomination, DenominationDetail } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { DenominationFormRules } from "../../helpers/validation-rules";
import { shopService } from "../../services/shop-service";
import { cashNoteService } from "../../services/cash-note-service";
import { denominationService } from "../../services/denomination-service";

export default {
  name: "DenominationDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Denomination",
        disabled: false,
        to: "denominations",
      },
      {
        text: "Denominations Detail",
        disabled: true,
      },
    ],
    typeList: [
      { label: "Cash Sale", value: "CASH_SALE" },
      { label: "Credit Sale (Cash Receive)", value: "CREDIT_SALE" },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    updatedDate: "",
    createdDate: "",
    issueDate: "",
    responseError: "",
    oldCurrencyName: "",
    status: "DRAFT",
    isEdit: false,
    denomination: new Denomination(),
    oldDenomination: new Denomination(),
    denominationDetail: new DenominationDetail(),
    oldDenominationDetail: new DenominationDetail(),
    rules: new DenominationFormRules(),
    shopList: [],
    currencyList: [],
    cashNoteList: [],
  }),
  watch: {
    denomination: {
      handler() {
        this.calculateReceiveCashAmount();
      },
      deep: true,
    },
  },
  created() {
    this.getAllShop();
    this.getActiveCashNote();
    this.getActiveCurrency();

    const id = this.$route.params.id;
    if (id == "new") {
      if (this.user.role.roleName == "SALE_MANAGER") {
        this.denomination.shopId = this.user.shopId;
      }
      // new stockin
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
    } else {
      this.getDenominationDetail(id);
    }
  },
  methods: {
    getActiveCashNote() {
      cashNoteService
        .getCashNoteByStatus("ACTIVE")
        .then((res) => {
          this.cashNoteList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveCurrency() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeCurrency(currencyId) {
      this.denomination.denominationDetailList = [];
      let currency = commonService.search("id", currencyId, this.currencyList);
      if (currency) {
        if(this.isEdit){
          if(this.oldCurrencyName == currency.name){
            this.oldDenominationDetail.forEach((temp)=>{
              this.denomination.denominationDetailList.push(temp);
            });
          }
          else{
            this.cashNoteList.forEach((temp) => {
              if (temp.currencyCode == currency.code) {
                this.denominationDetail = new DenominationDetail();
                this.denominationDetail.cashNoteId = temp.id;
                this.denominationDetail.cashNoteValue = temp.value;
                this.denominationDetail.qty = 0;
                this.denominationDetail.cashAmount = 0.0;
                this.denomination.denominationDetailList.push(this.denominationDetail);
              }
            });
          }
        }else{
          this.cashNoteList.forEach((temp) => {
            if (temp.currencyCode == currency.code) {
              this.denominationDetail = new DenominationDetail();
              this.denominationDetail.cashNoteId = temp.id;
              this.denominationDetail.cashNoteValue = temp.value;
              this.denominationDetail.qty = 0;
              this.denominationDetail.cashAmount = 0.0;
              this.denomination.denominationDetailList.push(this.denominationDetail);
            }
          });
        }
      }
    },
    calculateReceiveCashAmount() {
      let totalCashAmount = 0.0;
      this.denomination.denominationDetailList.forEach((item) => {
        item.cashAmount = item.qty * item.cashNoteValue;
        totalCashAmount += item.cashAmount;
      });
      this.denomination.cashAmount = parseFloat(totalCashAmount).toFixed(2);
    },
    getDenominationDetail(id) {
      denominationService
        .getDenominationDetail(id)
        .then((res) => {
          this.denomination = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.denomination.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.denomination.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.issueDate = commonService.millisecondToDate(
            this.denomination.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.status = this.denomination.status;
          // deep copy
          this.oldDenomination = JSON.parse(JSON.stringify(res.data));
          this.oldDenominationDetail = JSON.parse(JSON.stringify(res.data.denominationDetailList));
          this.oldCurrencyName = res.data.currencyName;
          this.isEdit = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.denomination.id) {
        this.denomination = new Denomination();
        this.denomination.denominationDetailList = [];
        if (this.user.role.roleName == "SALE_MANAGER") {
          this.denomination.shopId = this.user.shopId;
        }
      } else {
        this.denomination = Object.assign({}, this.oldDenomination);
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        //convert to millisecond
        this.denomination.issueDateInMilliSeconds =
          commonService.convertToMilliseconds(this.issueDate);

        denominationService
          .saveDenomination(this.denomination)
          .then((res) => {
            if (res) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    goBack() {
      this.$router.push("/denominations");
    },
  },
};
</script>
